import { createAsyncThunk } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import api from "../../api";

export const GetUsers = createAsyncThunk(
  "ls/GetUsers",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.get(`/users`, payload);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

export const SuspendUser = createAsyncThunk(
  "ls/SuspendUser",
  async (payload, { rejectWithValue, getState, dispatch }) => {
    try {
      const response = await api.put(`/admin/suspend/${payload}`, {
        status: "SUSPENDED",
      });
      toast.success(response?.data?.message);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.statusMessage || "An error occured");
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  Users: {},
};

export const UserSlice = createSlice({
  name: "Users",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(GetUsers.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(GetUsers.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccessful: true,
          Users: action.payload,
        };
      })
      .addCase(GetUsers.rejected, (state, action) => {
        return {
          isLoading: false,
          error: action.payload,
        };
      });

    builder
      .addCase(SuspendUser.pending, (state) => {
        return {
          ...state,
          isSuspending: true,
        };
      })
      .addCase(SuspendUser.fulfilled, (state, action) => {
        return {
          ...state,
          isSuspending: false,
          isSuccessful: true,
          suspend_user: action.payload,
        };
      })
      .addCase(SuspendUser.rejected, (state, action) => {
        return {
          isSuspending: false,
          error: action.payload,
        };
      });
  },
});

export default UserSlice.reducer;
